import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { State } from '../../redux/store';
import { PartnerInterface } from '../Partners/types';
import { hostName } from '../../requestMethods';
import { useTranslation } from 'react-i18next';
import { pageDirContext } from '../../App';

const OurPartner: React.FC = () => {
  const { partners } = useSelector((state: State) => state.partners);
  const { t } = useTranslation();
  
  const { pageDir } = useContext(pageDirContext)

  return (
    <section className={`my-4 bg-gray-200`} dir={pageDir}>
      <div className='bg-white py-8'>
        <p className='text-center text-main font-bold text-2xl mb-6'>{t("Nos Partenaires")}</p>
        <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-4'>
          {partners?.map((partner: PartnerInterface, index) => (
            <div 
              className='flex flex-col items-center bg-white shadow-lg rounded-lg p-4 transition-all transform hover:shadow-xl hover:scale-105 hover:rotate-2 duration-300 hover:cursor-pointer motion-safe:animate-fade-in' 
              key={index}
            >
              <img 
                className='rounded-full w-32 h-32 border-4 border-main mb-4 transition-transform transform hover:scale-110 motion-safe:animate-fade-in' 
                src={hostName + "imgs/partners/" + partner.image} 
                alt={`${partner.name}-img`} 
              />
              <p className='text-lg font-semibold'>{partner.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPartner;
